import React from 'react';

import { Box, Divider } from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';

import HeaderCharges from './components/header';
import ListCharges from './components/list';
import NotificationModal from '../components/notificationModal';

function Charges() {
  const toggle = useToggle('new_ds_charges');

  if (!toggle) { return (<NotificationModal />); }

  return (
    <Box mb={10}>
      <HeaderCharges />

      <Divider />

      <ListCharges />
    </Box>
  );
}

export default Charges;
